<!--下单-->
<template>
  <div>
    <!-- 下单 -->
    <div class="address flex-between" @click="addressPickerShow = true">
      <div class="address-left flex-start">
        <img
          class="address-img"
          src="../../../assets/newImg/icon-address-location.png"
          alt
        />
        <div class="address-detail">
          <div class="address-pro">{{ address.address }}</div>
          <div class="address-phone">
            {{ address.name }} {{ address.phone }}
          </div>
        </div>
      </div>
      <div class="address-right">
        <img
          class="icon-right-tip"
          src="../../../assets/images/icon-right.png"
          alt
        />
      </div>
      <div class="address-back"></div>
    </div>
    <!--<div class="flex-between row">
        <div>优惠券</div>
        <div class="row-right flex-end">
            -¥12.00<img class="icon-right" src="../../../assets/images/icon-right.png" alt="">
        </div>
    </div>-->
    <div class="border-top" v-for="(order, index) in order_list" :key="index">
      <!-- <div class="row-title" v-if="order.open_seller_fenxiao == 2">
        <div class="title-left">
          <img class="row-title-img" :src="order.business_pic_url" alt />
          {{ order.business_name }}
        </div>
        <div
          @click="couponSelect(index)"
          class="title-right"
          v-if="order.coupon_list.length > 0"
        >
          选择优惠券({{ order.coupon_list.length }})
        </div>
      </div> -->

      <div v-for="(goods, index2) in order.goods_items" :key="index2">
        <div class="flex-between row-between">
          <div class="between-left flex-start">
            <img class="between-left-img" :src="goods.pic_url" alt />
            <div class="goods-box">
              <div class="between-left-title show-one-row">
                {{ goods.title }}
              </div>
              <div
                class="between-left-detail gray-light"
                v-if="!goods.sku_show"
              >
                {{ goods.sku.sku_formart }}
              </div>
              <div
                class="between-left-detail gray-light"
                @click="onGoodsSkuPicker(goods, index2)"
                v-else
              >
                <span
                  v-if="goods.sku_id"
                  style="
                    padding: 0 0.1rem;
                    border: 1px solid #999;
                    border-radius: 0.2rem;
                  "
                  >{{ goods.sku.sku_formart }}</span
                >
                <span
                  style="
                    padding: 0 0.1rem;
                    border: 1px solid #999;
                    border-radius: 0.2rem;
                  "
                  v-else
                  >选择规格</span
                >
              </div>
              <div class="between-left-price" v-if="goods.sku_id">
                ¥{{ goods.price }}
              </div>
              <div
                class="between-left-price"
                @click="onGoodsSkuPicker(goods, index2)"
                v-else
              >
                规格待选择
              </div>
            </div>
          </div>
          <div class="between-right">
            <div class="between-right-num gray-light" v-if="goods.count_show">
              <span>数量</span>
              {{ goods.count }}
            </div>
            <div
              class="between-right-num gray-light"
              v-else
              style="min-width: 1.84rem"
            >
              <!-- <span>数量</span> -->
              <van-stepper
                @change="onGoodsCountChange"
                disable-input
                v-model="goods.count"
                min="0"
                :max="goods.stock"
              />
            </div>
          </div>
        </div>
        <!-- <van-cell-group v-if="pageData.total_credit > 0">
          <van-cell
            title="使用积分"
            :label="'已抵扣' + goods.discount_price + '元'"
          >
            <van-stepper
              :min="0"
              integer
              :max="credit_limit[index2]"
              v-model="goods.use_credit"
            />
          </van-cell>
          <van-notice-bar v-if="pageData.cert_status">
            <span v-if="credit_limit[index2] > 0"
              >您有{{ pageData.total_credit }}积分,本商品最多可使用{{
                credit_limit[index2]
              }}积分</span
            >
            <span v-else>该商品不可使用 积分</span>
          </van-notice-bar>
          <van-notice-bar
            v-else
            v-rblink="{ name: 'certPersonalOcr', query: {} }"
            >您有{{ pageData.total_credit }}积分,实名认证后可用
            &gt;</van-notice-bar
          >
        </van-cell-group> -->
      </div>

      <div class="flex-between row-list border-bottom">
        <div>商品金额</div>
        <div class="row-right flex-end">¥{{ order.goods_price }}</div>
      </div>
      <div class="flex-between row-list border-bottom">
        <div>运费</div>
        <div class="row-right flex-end">¥{{ order.express_price }}</div>
      </div>
      <div class="flex-between row-list border-bottom">
        <div>优惠</div>
        <div class="row-right flex-end">
          <span>¥{{ discount_price }}</span>
        </div>
      </div>
      <div class="row-list">
        <div>买家留言</div>
        <div class="message-text">
          <input
            type="text"
            placeholder="您还有其他什么要求..."
            @change="noteChange(order.business_id, $event)"
          />
        </div>
      </div>
    </div>
    <div class="chima" v-if="chima_show">
      <van-button  size="small" type="primary" @click="onDown">尺码表</van-button>
    </div>
    <div style="height: 44px"></div>
    <div class="footer flex-between">
      <div class="footer-left flex-start">
        <span class="gray">总计</span>
        ¥{{ pay_price }}
      </div>
      <!--            <div class="footer-right" @click="payDialogShow=true">去支付</div>-->
      <div class="footer-right" @click="submit" v-if="!submitLoading">
        去支付
      </div>

      <div class="footer-right" v-else>提交中...</div>
    </div>
    
    <AddressPicker
      :show="addressPickerShow"
      @onChange="changeAddress"
      @onClose="closeAddress"
    />
    <PayDialog
      scene="sales"
      :show="payDialogShow"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
    <CouponPicker
      :show="couponPickerShow"
      :list="currentCouponList"
      @onChange="changeCoupon"
      :business_id="currentBusinessId"
      :index="currentBusinessIndex"
    />
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    <!-- 基础用法 -->
    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :quota="skuData.quota"
        :quota-used="skuData.quotaUsed"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        buy-text="确定"
        add-cart-text="增加"
        @buy-clicked="onGoodsSkuSave"
        @add-cart="onAddCartClicked"

      >
        <span slot="sku-stepper"> </span>
      </van-sku>
    </div>
  </div>
</template>
<style scoped>
.sku-container >>> .van-button--warning {
  color: #fff;
  background-color: #f44;
}

.sku-container >>> .van-button--danger {
  color: #fff;
  background-color: #ff976a;
  border: 1px solid #ff976a;
}
.message-text {
  padding-top: 5px;
}

.message-text input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}

.message-text input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}

.message-text input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}

.message-text input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}

.icon-right-tip {
  width: 16px;
  height: 16px;
}

.goods-box {
  max-width: 230px;
}

.van-hairline--top-bottom::after {
  border: none;
}

.van-cell {
  padding: 5px 0.31rem;
}

.address {
  padding: 0.3rem 0.2rem 0.3rem 0.36rem;
  position: relative;
}

.border-top {
  border-top: 0.1rem solid #efefef;
}

.border-bottom {
  border-bottom: 1px solid #efefef;
}

.address-img {
  width: 0.33rem;
  height: 0.42rem;
  margin-right: 0.2rem;
}

.address-detail {
  font-size: 12px;
  color: #333333;
}

.address-back {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: url("../../../assets/newImg/bg-address-line.png");
  background-size: 1.7rem 2px;
}

.row {
  padding: 0.2rem 0.31rem;
  color: #333333;
}

.row-title {
  padding: 0.2rem 0.33rem;
  display: flex;
  /*justify-content: flex-start;*/
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #efefef;
}

.row-title-img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
}

.title-left {
  display: flex;
  align-items: center;
}
.show-one-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.title-right {
  background: #fd2840;
  color: #fff;
  padding: 4px;
  border-radius: 4px;
}

.between-left-img {
  width: 1.1rem;
  min-width: 1.1rem;
  height: 1.1rem;
  margin-left: 0.16rem;
  margin-right: 0.2rem;
}

.row-between {
  padding: 0.2rem 0;
  /*margin: 0 0.15rem;*/
  margin: 0 0.31rem 0 0.15rem;
  border-bottom: 1px solid #efefef;
}

.row-between:last-of-type {
  border: none;
}

.between-left-detail {
  font-size: 11px;
  margin: 0.1rem 0;
}

.between-left-price {
  color: #f05656;
}

.between-right-num span {
  font-size: 12px;
}

.between-right {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 1.2rem;
}

.row-list {
  margin: 0 0.31rem;
  padding: 0.2rem 0;
}

.row-list span {
  color: #f05656;
}

.leave {
  margin-bottom: 0.2rem;
}
.chima{
  position: fixed;
  height: 44px;
  left: 0;
  bottom: 44px;
  width: 100%;
  background: #fff;
}
.footer {
  position: fixed;
  height: 44px;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
}

.footer-left {
  color: #111111;
  font-size: 17px;
  padding-left: 0.33rem;
  width: 4.39rem;
  border-top: 1px solid #efefef;
  height: 44px;
}

.footer-left span {
  font-size: 12px;
  margin-right: 0.2rem;
}

.footer-right {
  width: 3.11rem;
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  color: #fff;
  background: rgba(253, 40, 64, 1);
}
</style>

<script>
import LoginDialog from "@/components/LoginDialog.vue";
import AddressPicker from "@/components/AddressPicker.vue";
import PayDialog from "@/components/PayDialog.vue";
import CouponPicker from "@/components/CouponPicker.vue";
import { Field, Notify, Toast, Sku, Loading } from "vant";
import Vue from "vue";
Vue.use(Loading);
export default {
  name: "OrdersCheck",
  components: {
    [Field.name]: Field,
    AddressPicker,
    PayDialog,
    Notify,
    CouponPicker,
    LoginDialog,
    Toast,
    Sku,
  },
  data: function () {
    return {
      no_show: false,
      chima_show:false,
      closeOnClickOverlay: true,
      showSkuPicker: false,
      messageConfig: {},

      loginShow: false,
      addressPickerShow: false,
      payDialogShow: false,
      couponPickerShow: false,
      currentCouponList: [],
      currentBusinessIndex: 0,
      currentBusinessId: 0,
      message: "",

      formData: {
        needLoadingIndicator: true,
        address_id: 0,
        goods_items: [],
        notes: {},
        coupon_used: {},
      },
      formData2: {
        sale_id: 0,
        address_id: 0,
        goods_items: [],
      },
      address: {},
      // pay_price: 0,
      orderIds: [],
      warnings: [],
      submitDisabled: true,
      submitLoading: false,

      order_list: [],
      pageData: {
        address: {
          id: 0,
        },
        discounts: [],
        goods_items: [],
        goods_price: "",
        express_price: "",
        discount_price: "",
        order_price: "",
        cert_status: false,
      },
      skuData: {
        sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: [],
          messages: [],
        },
        goods: {},
        goods_id: 0,
        quota: 0,
        quotaUsed: 0,
      },
      check_goods_sku_index: -1, //当前选择sku规格商品的下标
    };
  },
  computed: {
    discount_price: function () {
      let that = this;
      let used_credit = 0;
      let discount_price = 0;
      this.pageData.goods_items.map(function (goods) {
        goods.discount_price =
          goods.price * goods.count -
            that.pageData.credit_to_price * goods.use_credit <
          0
            ? goods.price * goods.count
            : that.pageData.credit_to_price * goods.use_credit;
        discount_price += goods.discount_price;
      });
      return discount_price.toFixed(2);
    },
    pay_price: function () {
      console.log("order_price");
      console.log(this.pageData.goods_items);
      console.log("discount_price", this.discount_price);
      //            console.log(this.discount_price);
      let sum_price = 0;
      this.pageData.goods_items.map((item, i) => {
        sum_price += item.count * parseInt(item.price);
      });
      console.log(sum_price);
      let pay_price =
        this.pageData.pay_price - this.discount_price < 0
          ? 0
          : this.pageData.pay_price - this.discount_price;
      return pay_price.toFixed(2);
    },
    credit_limit: function () {
      let that = this;
      console.log("credit_limit");
      let limit_arr = [];
      let used_credit = 0;
      console.log(this.pageData);
      this.pageData.goods_items.map(function (goods) {
        used_credit += parseInt(goods.use_credit);
      });

      let last_credit = this.pageData.total_credit - used_credit;
      console.log("last_credit");
      console.log(last_credit);
      this.pageData.goods_items.map(function (goods, index) {
        if (that.pageData.total_credit == 0) {
          limit_arr[index] = 0;
        } else {
          if (that.pageData.cert_status) {
            // console.log(goods.credit_limit*(parseInt(goods.count))+'||'+ (goods.use_credit+last_credit));
            // return

            limit_arr[index] =
              goods.credit_limit * goods.count >= goods.use_credit + last_credit
                ? goods.use_credit + last_credit
                : goods.credit_limit * goods.count;
          } else {
            limit_arr[index] = 0;
          }
        }
      });
      console.log("limit_arr");
      console.log(limit_arr);
      return limit_arr;
    },
  },
  watch: {
    message(val) {
      console.log(val);
    },
  },

  filter: {},
  mounted() {
    document.title = "提交订单";
    this.getOrderLoad();
  },
  destroyed() {},
  methods: {
    onDown(){
      appEvent({
        name: 'downloadFile',
        query: {
          name:'客户订购单',
          url:'https://api.ccachina.net/xlsx/客户订购单.xlsx',
        }
      });
    },
    onAddCartClicked(data) {
      // console.log(data)
      let that=this
      let goods_items = {
        goods_id: data.goodsId,
        sku_id: data.selectedSkuComb.id,
        count: data.selectedNum
      };
      let flg=false
      that.formData2.goods_items.map((item,i)=>{
        if(item.sku_id==data.selectedSkuComb.id){
          item.count+=1
          flg=true
        }
      })
      if(!flg){
        that.formData2.goods_items.push(goods_items)
      }
      that.getOrderLoad();
    },
    onGoodsSkuSave(data) {
      console.log(data.selectedSkuComb);
      this.formData2.goods_items[this.check_goods_sku_index].sku_id =
        data.selectedSkuComb.id;
      this.getOrderLoad();
      this.check_goods_sku_index = -1;
      this.showSkuPicker = false;
    },
    onGoodsSkuPicker(goods, index) {
      let that = this;
      let sku = {};
      let total = 0;
      this.check_goods_sku_index = index;
      this.$api.get("/api/goods/goodsdetail", { id: goods.goods_id }, (res) => {
        let data = res.data.data;

        that.skuData.sku = sku = res.data.sku;
        that.skuData.sku.messages = [];
        //

        // 计算总图片数量

        that.skuData.goods = {
          title: res.data.data.title,
          picture: res.data.data.pic_url,
        };

        // 总数量
        for (let i = 0; i < sku.list.length; i++) {
          total = total + sku.list[i].stock_num;
        }

        that.skuData.sku.stock_num = total;
        that.skuData.sku.price =
          res.data.data.price_range[0] + "-" + res.data.data.price_range[1];
        that.skuData.goods_id = res.data.data.id;
        that.skuData.quota = res.data.data.user_buy_limit;
        that.skuData.quotaUsed = res.data.data.buy_count;
        that.showSkuPicker = true;
      });
    },
    // 获取订单详细信息
    getOrderLoad() {
      let that = this;

      this.formData2.sale_id = that.$route.query.sale_id;
      console.log(that.formData2);
      // return
      that.$api.post(
        "/api/jxc/saleOrderForm",
        that.formData2,
        (res) => {
          console.log(res.data);
          Toast.clear();
          // return
          that.address = res.data.address;
          that.order_list = res.data.order_list;
          that.pageData = res.data.order_list[0];
          // that.pay_price = res.data.pay_price;
          that.formData2.address_id = res.data.address_id;
          that.formData2.goods_items = res.data.order_list[0].goods_items;

          // 判断有没有warning
          if (res.data.warnings.length > 0) {
            Notify({
              message: res.data.warnings[0],
              duration: 2000,
              background: "#FF4444",
            });
            that.warnings = res.data.warnings;
            that.submitDisabled = true;
          } else {
            that.submitDisabled = false;
          }
          res.data.order_list.map((order,o)=>{
            order.goods_items.map((item,i)=>{
              if(item.title.indexOf("服") != -1){
                this.chima_show=true
              }
            })
          })
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      let that = this;
      that.loginShow = false;
      that.getOrderLoad();
    },

    loginCancel() {
      console.log("-------取消登录--------");
    },

    // 添加留言
    noteChange(order_id, event) {
      let that = this;
      that.formData2.notes[order_id] = event.target.value;

      console.log(that.formData);
    },

    changeAddress(address) {
      let that = this;
      console.log("更换地址", address);
      that.addressPickerShow = false;

      that.formData2.address_id = address.address_id;
      that.getOrderLoad();
    },
    closeAddress() {
      let that = this;
      console.log("closeAddress");
      that.addressPickerShow = false;
    },
    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
        {
          name: "OrderList",
          query: {},
        },
        "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      that.payDialogShow = false;
      rbLink(
        {
          name: "OrderList",
          query: {},
        },
        "replace"
      );
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;
      rbLink(
        {
          name: "OrderList",
          query: {},
        },
        "replace"
      );
    },

    couponSelect(index) {
      let that = this;

      console.log(index);
      /*that.currentCouponList = that.order_list[index].coupon_list;
                that.currentBusinessId = that.order_list[index].business_id;*/
      that.currentCouponList = that.order_list[index].coupon_list;
      that.currentBusinessId = that.order_list[index].business_id;
      that.currentBusinessIndex = index;
      console.log("弹出优惠券选择器");
      that.couponPickerShow = true;
    },

    changeCoupon(data) {
      let that = this;
      // console.log('优惠券变化', data);
      that.formData2.coupon_used[data.business_id] = data.list;

      that.couponPickerShow = false;
      that.couponDiscountCompute(data.index, data.list);
    },

    // 提交订单
    submit() {
      let that = this;
      if (that.submitLoading) {
        return false;
      }
      if (that.submitDisabled) {
        Notify({
          message: that.warnings,
          duration: 2000,
          background: "#FF4444",
        });
        return false;
      }
      that.submitLoading = true;
      that.formData2.goods_items=JSON.stringify(that.formData2.goods_items) 
      this.$api.post(
        "/api/jxc/orderAdd",
        that.formData2,
        (res) => {
          console.log(res);
          that.orderIds = res.data.ids;
          that.payDialogShow = true;
          // this.selectComponent('#payDialog').payDialogShow(ids);
        },
        (res) => {
          that.submitLoading = false;

          Notify({
            message: res.msg,
            duration: 2000,
            background: "#FF4444",
          });
        }
      );
    },

    // 判断优惠券和订单价格
    couponDiscountCompute(index, list) {
      let that = this;
      let discountPrice = 0;
      list.map((item) => {
        discountPrice += parseFloat(item.price);
      });
      let orderPrice =
        parseFloat(that.order_list[index].goods_price) +
        parseFloat(that.order_list[index].express_price);
      if (discountPrice > orderPrice) {
        //优惠金额不能大于订单金额
        discountPrice = orderPrice;
      }

      // console.log(discountPrice,orderPrice)
      // 更改选择订单的优惠金额
      that.order_list[index].discount_price = discountPrice;
      that.payPriceCompute();
    },

    // 使用优惠券后的支付总金额
    payPriceCompute() {
      let that = this;
      let payPrice = 0;
      that.order_list.map((order) => {
        let orderPayPrice = 0;
        orderPayPrice =
          parseFloat(order.goods_price) +
          parseFloat(order.express_price) -
          parseFloat(order.discount_price);
        payPrice += orderPayPrice;
      });

      // console.log(payPrice)
      that.pay_price = payPrice;
    },
    onGoodsCountChange() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.getOrderLoad();
    },
  },
};
</script>



// WEBPACK FOOTER //
// OrdersCheck.vue?336b892c